import { createGlobalStyle } from "styled-components";

import GothamBook from "../../fonts/gotham-book-webfont.woff";
import GothamMedium from "../../fonts/gotham-medium-webfont.woff";
import P22Mackinac from "../../fonts/p22mackinac-medium-webfont.woff";
import BNPenAndGram from "../../fonts/bnpenandgram-regular-webfont.woff";

// 1: Normalize
// 2: General stuff
// 3: Font
// 4: Utils
// 5: Parallax basic setup
// 6: Lazyload
// 7: Languages exception

// colors legend:
// main color: #305940
// gray text: #505050
// cta color: #D1122E
// main background color: #EDF6F2
// bacgrkoud cream: #F8F8ED

const GlobalStyle = createGlobalStyle`
    html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;box-sizing:border-box}*,:after,:before{box-sizing:inherit}body,figure{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent;text-decoration:none;color:inherit;}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0;border-radius:0;}button{overflow:visible;-webkit-appearance:none;-moz-appearance:none;padding:0;border:0 none}button,select{text-transform:none}html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:0;margin:0;padding:0}legend{border:0;padding:0}textarea{overflow:auto;resize:vertical;vertical-align:top}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0;width:100%}td,th{padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}iframe,img,object,video{max-width:100%}iframe,object,video{display:block;width:100%;}:-moz-ui-invalid{box-shadow:none}::-ms-clear {display: none}::-ms-expand{display:none;}




	html {
  		position: relative;
	}
    html.show-menu {
        overflow: hidden;
    }
    html.show-popup {
        overflow: hidden;
    }
	body {
	  	position: relative;
        background-color: #EDF6F2;
        color: #305940;
	}
    body.show-menu {
        overflow: hidden;
    }
    body.show-popup {
        overflow: hidden;
    }
	::-moz-selection {
	    background: #D1122E;
	    color: #FFFFFF;
	    text-shadow: none;
	}
	::selection {
	    background: #D1122E;
	    color: #FFFFFF;
	    text-shadow: none;
	}
	.ferrarelleMaximaPage ::-moz-selection {
	    background: #04080B;
	    color: #FFFFFF;
	    text-shadow: none;
	}
	.ferrarelleMaximaPage ::selection {
	    background: #04080B;
	    color: #FFFFFF;
	    text-shadow: none;
	}
	button, select {
	    background-color: transparent;
	    border-color: transparent;
	    cursor: pointer;
	}
	img {
	    max-width: 100%;
	}
	svg {
	  	width: 1.25rem;
	  	height: 1.25rem;
	}
	main {
	    position: relative;
	    min-height: 90vh; // main is at least full-page (without header)
	}
	figure {
	  	margin: 0;
	}




	@font-face {
  		font-family: "gothambook";
  		src: url(${GothamBook}) format("woff");
        font-weight: normal;
        font-style: normal;
  		font-display: fallback;
  	}
    @font-face {
        font-family: "gothammedium";
        src: url(${GothamMedium}) format("woff");
        font-weight: normal;
        font-style: normal;
        font-display: fallback;
    }
	@font-face {
  		font-family: "p22_mackinacmedium";
        src: url(${P22Mackinac}) format("woff");
  		font-style: normal;
  		font-weight: normal;
  		font-display: fallback;
  	}
    @font-face {
        font-family: "bn_penandgrammedium";
        src: url(${BNPenAndGram}) format("woff");
        font-style: normal;
        font-weight: normal;
        font-display: fallback;
    }



	html {
        font-family: "gothambook", sans-serif;
  		font-size: 14px;
      line-height: 1.4;
  		@media screen and (min-width: 480px) {
  			font-size: calc(14px + 2 * ((100vw - 480px) / 800));
  		}
  		@media screen and (min-width: 1280px) {
  			font-size: 16px;
  		}
  		@media screen and (min-device-width: 1024px) and (max-device-width: 1920px) and (-webkit-min-device-pixel-ratio: 1.25) and (-webkit-min-device-pixel-ratio: 1.25), screen and (min-device-width: 1024px) and (max-device-width: 1920px) and (-webkit-min-device-pixel-ratio: 1.25) and (min-resolution: 120dpi) {
  			font-size: 90%;
  		}
  		@media screen and (min-device-width: 1024px) and (max-device-width: 1920px) and (-webkit-min-device-pixel-ratio: 1.5) and (-webkit-min-device-pixel-ratio: 1.5), screen and (min-device-width: 1024px) and (max-device-width: 1920px) and (-webkit-min-device-pixel-ratio: 1.5) and (min-resolution: 144dpi) {
			font-size: 80%;
  		}
  		@media screen and (min-device-width: 1024px) and (max-device-width: 2560px) and (-webkit-min-device-pixel-ratio: 2) and (-webkit-min-device-pixel-ratio: 2), screen and (min-device-width: 1024px) and (max-device-width: 2560px) and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi) {
  			font-size: 100%;
  		}
  	}
	h1, h2, h3, h4, h5, h6 {
  		font-family: "gothammedium", sans-serif;
        font-weight: normal;
      //font-weight: bold;
  		line-height: 1.2;
  		margin: .5rem 0;
  	}
  	h1, .h1 {
  		font-size: 4.45vw;
      margin-top: 0;
      @media screen and (min-width: 1440px) {
        font-size: 4rem;
      }
  		@media screen and (max-width: 1023px) {
			 font-size: 2.5rem;
  		}
  		@media screen and (max-width: 767px) {
  			font-size: 2.25rem;
  		}
  	}
    h2, .h2 {
        font-size: 2.5rem;
        @media screen and (max-width: 1023px) {
            font-size: 2.25rem;
        }
         @media screen and (max-width: 767px) {
             font-size: 2rem;
         }
    }
  	h3, .h3 {
  		font-size: 2.25rem;
  		@media screen and (max-width: 1023px) {
			font-size: 2rem;
  		}
  		@media screen and (max-width: 767px) {
  			font-size: 1.8rem;
  		}
  	}
  	h4, .h4 {
  		font-size: 2rem;
  		@media screen and (max-width: 1023px) {
			font-size: 1.8rem;
  		}
  		 @media screen and (max-width: 767px) {
  		 	font-size: 1.5rem;
  		 }
  	}
  	h5, h6, .h5, .h6 {
  		font-size: 1.5rem;
  		@media screen and (max-width: 1023px) {
			font-size: 1.25rem;
  		}
  		 @media screen and (max-width: 767px) {
  		 	font-size: 1.125rem;
  		 }
  	}

    .font-mackinac {
        font-family: "p22_mackinacmedium", sans-serif;
    }
    .font-bnpenandgram {
        font-family: "bn_penandgrammedium", sans-serif;
    }




  	.text__left {
  		text-align: left;
  	}
  	.text__right {
  		text-align: right;
  	}
	.text__center {
  		text-align: center;
  	}
  	.text__bigger {
  		font-size: 1.75rem;
  	}
	.text__big {
  		font-size: 1.25rem;
  	}
	.text__medium {
  		font-size: 1.125rem;
  	}
	.text__small {
  		font-size: .875rem;
  	}
	.text__smaller {
  		font-size: .75rem;
  	}
  	ul {
  		padding-left: 1.5rem;
  		list-style: disc;
  		list-style-position: outside;
  	}
  	ul li {
    	padding-left: .5rem;
    	margin-bottom: .5rem;
    }
  	ul.decimal {
    	list-style-type: decimal;
    }
    ul.lower-roman {
    	list-style-type: lower-roman;
    }
    ul.list-white-background  {
      padding: 1rem 2.5rem;
      background-color: rgba(255,255,255,0.85);
      border-radius: 1rem;
      width: calc(100% + 2rem);
      margin-left: -1rem;
      color: #D1122E;
    }
    nav ul {
  		list-style-type: none;
  		margin: 0;
  		padding: 0;
  	}
  	nav ul li {
    	display: inline-block;
    	padding: 0;
    }
	.ellipsed-text {
		display: block;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
		height: 1.4em;
		-webkit-line-clamp: 1;
	}
	.ellipsed-text--multiline {
		height: 6em;
		-webkit-line-clamp: 4;
	}
    .underline {
        text-decoration: underline;
    }
    .italic {
        font-style: italic;
    }
    .nowrap {
        white-space: nowrap;
    }
    .position-relative {
        position: relative;
    }
    .no-overflow-y {
        overflow-y: hidden;
    }
    .margin-auto {
        margin-left: auto;
        margin-right: auto;
    }
    .no-margin__all {
        margin: 0;
    }
    .no-margin__vertical {
        margin-top: 0;
        margin-bottom: 0;
    }
    .no-margin__top {
        margin-top: 0;
    }
    .no-margin__bottom {
        margin-bottom: 0;
    }
    .visually-hidden {
        position: absolute;
        overflow: hidden;
        clip: rect(0 0 0 0);
        height: 1px;
        width: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
    }
    .no-pointer-events {
      pointer-events: none;
    }

  @media screen and (min-width: 640px) {
    .mobile-hide {
      display: block !important;
    }
    .mobile-show {
      display: none !important;
    }
  }

  @media screen and (max-width: 639px) {
    .mobile-hide {
      display: none !important;
    }
    .mobile-show {
      display: block !important;
    }
  }

  @media screen and (min-width: 768px) {
    .tablet-hide {
      display: block !important;
    }
    .tablet-hide-inline {
      display: inline-block !important;
    }
    .tablet-show, .tablet-show-inline {
      display: none !important;
    }
  }

  @media screen and (max-width: 767px) {
    .tablet-hide, .tablet-hide-inline {
      display: none !important;
    }
    .tablet-show {
      display: block !important;
    }
    .tablet-show-inline {
      display: inline-block !important;
    }
  }

  @media screen and (min-width: 1024px) {
    .desktop-hide {
      display: block !important;
    }
    .desktop-show {
      display: none !important;
    }
  }

  @media screen and (max-width: 1023px) {
    .desktop-hide {
      display: none !important;
    }
    .desktop-show {
      display: block !important;
    }
  }

  .spacer {
    height: 6.25rem;
  }
    @media screen and (max-width: 1023px) {
      .spacer {
        height: 3.125rem;
      }
    }

  .mini-spacer {
    height: 2.5rem;
    &--negative {
        height: 0;
        margin-top: -2.5rem
    }
  }
    @media screen and (max-width: 1023px) {
      .mini-spacer {
        height: 1.25rem;
      }
    }

  .micro-spacer {
    height: 1.25rem;
  }

  .divider {
    width: 100%;
    height: 1px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    background-color: currentColor;
  }

  .bg__white {
    background-color: #FFFFFF;
  }
  .bg__1 {
    background-color: #EAFBFF;
  }
  .bg__2 {
    background-color: #D8F0E1;
  }
    .bg__3 {
        background-color: #F8F8ED;
    }
  .bg--6 {
    /* utilizzato nelle sezioni "azienda" */
    background-color: #F4F3EE;
  }
  .bg__maxima {
      background: linear-gradient(90deg, rgba(3,3,3,1) 0%, rgba(3,3,3,1) 40%, rgba(28,33,36,1) 100%);
  }
  .bg__americas-cup {
      background: linear-gradient(90deg, #0B0D13 0%, #0E1218 36.95%, #091D31 100%), #091D31;
  }

  .bg__image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .video__wrapper {
    position: relative;
    padding-bottom: 56.25%;
    margin-top: 3em;
    margin-bottom: 3em;
    height: 0;
  }

  .video__responsive {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .color__white {
    color: #FFFFFF;
  }
  .color__red {
    color: #D1122E;
  }
  .color__gray {
      color: #505050;
  }
    .color__dark-gray {
        color: #060608;
    }

  .z-index--1 {
    z-index: 1;
  }

  .z-index--2 {
    z-index: 2;
  }

  .z-index--3 {
    z-index: 3;
  }

  .z-index--4 {
    z-index: 4;
  }

  .z-index--5 {
    z-index: 5;
  }

  .z-index--6 {
    z-index: 6;
  }

  @media screen and (max-width: 767px) {
    .m-order--1 {
      order: 1;
    }
    .m-order--2 {
      order: 2;
    }
    .m-order--3 {
      order: 3;
    }
    .m-order--4 {
      order: 4;
    }
    .m-order--5 {
      order: 5;
    }
    .m-order--6 {
      order: 6;
    }
  }

    // Accessibility
    a, button, input, textarea, select, *[tabindex="0"] {
        &:focus-visible {
            outline: 2px auto currentColor;
            outline-offset: 0;
        }
    }




  .parallax-full {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .parallax-inner {
      height: 100%;
      width: 100%;
      transition: transform 0.5s ease;
      .transition-slow & {
          @media screen and (min-width: 768px) {
              transition-duration: 1.2s;
          }
      }
      .transition-fast & {
          @media screen and (min-width: 768px) {
              transition-duration: 0.3s;
          }
      }
  }




  .lazyload-placeholder {
    display: block;
    position: relative;
    height: 100%;
    min-height: 20rem;
  }



  // lo so che fa schifo sta roba, ma ci sono le immagini nel testo
  .logo-me-contro-te {
      max-height: 3.75rem;
      @media screen and (max-width: 768px) {
          max-height: 2.75rem;
      }
  }
  .logo-impatto {
      max-height: 3.75rem;
      @media screen and (max-width: 768px) {
          max-height: 2.75rem;
      }
  }
  .logo-pencil {
      max-height: 13rem;
      vertical-align: baseline;
      @media screen and (max-width: 768px) {
          max-height: 7rem;
      }
  }
  .logo-progetto-scuola {
      max-width: 40vw;
      @media screen and (max-width: 768px) {
        max-width: 90%;
      }
  }
  .v-a-text-bottom {
      vertical-align: text-bottom;
  }


    .relative {
        position: relative;
    }
`;

export default GlobalStyle;
